import { Backdrop, CircularProgress, Box } from '@mui/material';

export const WaitingBackdrop = ({loading}) => {
    return (
        <Backdrop
            sx={{ 
                color: '#FF8B93', 
                zIndex: (theme) => theme.zIndex.modal + 1,
                bgcolor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(8px)',
            }}
            open={loading}
            onClick={() => {}}
        >
            <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
            }}>
                <CircularProgress 
                    sx={{ 
                        color: '#FF8B93',
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                        },
                    }} 
                    size={40}
                    thickness={4}
                />
            </Box>
        </Backdrop>
    )
} 